import React from 'react';
import { Card, Col, Form, Row, Button, InputGroup } from 'react-bootstrap';
import PropTypes from 'prop-types';
import MaskedInput from 'react-text-mask';
import { useState, useEffect, useRef } from 'react';
import { useNavigate } from "react-router-dom";
import axios from 'helpers/api';
import { toast } from 'react-toastify';
import { useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import paths, { rootPaths } from '../../../routes/paths';
import HcpModal from './HcpModal';
import CommonBreadCrumb from 'components/commonbreadcrumb/CommonBreadCrumb';
import * as mapYourMedsConstant from '../../common/mapYourMedsConstant.js'
import FormValidations from 'components/FormValidations/FormValidations';
import Select from "react-select";
import ThemedSelect from 'components/commonbreadcrumb/ThemedSelect';

const AddEditHcpForm = ({ editData, onSuccess, onHide, isModal }) => {
    const [stateoptions, setStateOptions] = useState([]);
    const [options, setOptions] = useState([]);
    const [genderoptions, setGenderOptions] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [error, setError] = useState(false);
    const [specialityOptions, setSpecialityOptions] = React.useState([{ key: "Select a Speciality", value: "" }]);
    const location = useLocation();
    const locationData = editData || location.state;
    const initialFormData = {
        firstname: '',  //mand
        lastname: '',   //mand
        facilityname: '',   //mand
        speciality: '',
        address: '',
        gender: '',
        city: '',
        state: '',
        zip: '',
        phone: '',  //mand
        email: '',
        fax: '',
        isactive: true
    };

    const [formData, setFormData] = useState(initialFormData);

    const [date, setDate] = useState(null);

    const navigate = useNavigate();
    const formRef = useRef(null);

    const handleHcpModal = (event) => {
        setShowModal(true);
    };

    const fetchSpecialityData = async (selectedNewValue = null) => {
        let tokenStr = localStorage.getItem("accessToken");
        try {
            const res = await axios.get(`${process.env.REACT_APP_SERVER_URL}/doctors/list-doctor-speciality`, {
                headers: { 'Authorization': `Bearer ${tokenStr}` }
            });
            let objDocSpecialityData = res.data.data || [];
            let specialityResults = [];
            let matchedId = null;

            objDocSpecialityData.forEach((value) => {
                if (Number(value.is_active) === 1) {
                    specialityResults.push({
                        key: value.speciality,
                        value: value.id,
                    });
                    if (
                        selectedNewValue &&
                        (String(value.id) === String(selectedNewValue) ||
                         value.speciality.trim().toLowerCase() === String(selectedNewValue).trim().toLowerCase())
                    ) {
                        matchedId = value.id;
                    }
                }
            });
            setSpecialityOptions([{ key: 'Select a Speciality', value: '' }, ...specialityResults]);

            if (matchedId) {
                setFormData(prev => ({ ...prev, speciality: matchedId }));
            }
            return specialityResults;
        } catch (err) {
            console.error("Error fetching doctor speciality:", err);
        }
    };

    useEffect(() => {
        async function fetchProviderData() {

            let tokenStr = localStorage.getItem("accessToken");
            let results = JSON.parse(localStorage.getItem("facilitiesData")) || [];

            // Update the options state
            setOptions([
                { key: 'Select a program', value: '' },
                ...results
            ]);

            setStateOptions([
                { key: 'Select a state', value: '' },
                ...mapYourMedsConstant.STATE_VALUES
            ]);

            setGenderOptions([
                {
                    key: 'Select a gender', value: ''
                },
                {
                    key: 'Male', value: 'M'
                },
                {
                    key: 'Female', value: 'F'
                },
                {
                    key: 'Others', value: 'O',
                }
            ]);

            await fetchSpecialityData();

            if (locationData != null) {
                setFormData({
                    firstname: locationData.firstname || '',  //mand
                    lastname: locationData.lastname || '',   //mand
                    facilityname: '',   //mand
                    address: locationData.address || '',
                    gender: locationData.gender || '',
                    city: locationData.city || '',
                    state: locationData.state || '',
                    zip: locationData.zip || '',
                    phone: locationData.phone || locationData.officephone || '',  //mand
                    email: locationData.email || '',
                    fax: locationData.fax || '',
                    isactive: locationData.isactive == 1 || locationData.isactive === true ? true : false,
                    speciality: locationData.doctors_speciality_id || locationData.speciality || ''
                });

                if (locationData.speciality != "" && locationData.speciality != null) {

                    if (typeof locationData.speciality === 'string' && locationData.speciality.includes(",")) {
                        let specialityArray = locationData.speciality.split(',')
                        for (var i = 0; i < specialityArray.length; i++) {
                            setSpecialityOptions(prev => [...prev, { key: specialityArray[i], value: specialityArray[i] }])
                        }
                    }
                    else {
                        setSpecialityOptions(prev => [...prev, { key: locationData.speciality, value: locationData.doctors_speciality_id || locationData.speciality }])
                    }

                }
            } else {
                setFormData(initialFormData);
            }
        }

        // Trigger the fetch
        fetchProviderData();
    }, [editData]);

    const validations = () => {
        let newErrors = {};
        // if (formData.email && !FormValidations(formData.email, 5)) {
        //     newErrors.email = "Please Enter Correct Email Address"
        // }
        if (formData.fax && !FormValidations(formData.fax, 4)) {
            newErrors.fax = "Please Enter Correct Fax Number"
        }
        if (formData.phone && !FormValidations(formData.phone, 4)) {
            newErrors.phone = "Please Enter Correct Phone Number"
        }
        if (formData.zip && !FormValidations(formData.zip, 3)) {
            newErrors.zip = "Please Enter Correct Zip Number"
        }
        setError(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // Handler
    const handleSubmit = async e => {
        e.preventDefault();
        if (!validations()) {
            return;
        }
        if (e.target.name == "specialitymainform") {

            let tokenStr = localStorage.getItem("accessToken");
            let pelmedsHcpUrl = locationData != null ? `${process.env.REACT_APP_SERVER_URL}` + "/doctors/edit-doctor" : `${process.env.REACT_APP_SERVER_URL}` + "/doctors/add-doctor";

            let specialityManual = [];

            specialityOptions.map((specialityoption) => {

                if (specialityoption.value != "") {
                    specialityManual.push(specialityoption.value);
                }
            });

            let pelmedsHcpData = locationData != null ?
                {
                    "id": locationData.doc_id || locationData.id,
                    "group_id" : localStorage.getItem("groupId") || '',
                    "firstname": formData.firstname,
                    "lastname": formData.lastname,
                    "address": formData.address,
                    "doctors_speciality_id": formData.speciality,
                    "city": formData.city,
                    "state": formData.state,
                    "zip": formData.zip,
                    "phone": formData.phone,
                    "fax": formData.fax,
                    "is_active": formData.isactive ? 1 : 0,
                } :
                {
                    "group_id" : localStorage.getItem("groupId") || '',
                    "firstname": formData.firstname,
                    "lastname": formData.lastname,
                    "address": formData.address,
                    "doctors_speciality_id": formData.speciality,
                    "city": formData.city,
                    "state": formData.state,
                    "zip": formData.zip,
                    "is_active": 1,
                    "phone": formData.phone,
                    "fax": formData.fax,
                }

            const { data } = await axios.post(pelmedsHcpUrl, pelmedsHcpData, { headers: { 'Authorization': `Bearer ${tokenStr}` } });

            if (data.status) {
                toast.success("Doctors added/updated successfully");
                if (onSuccess) {
                    onSuccess();
                } else {
                    navigate(paths.viewHcp);
                }
            }
            else {
                toast.info("Error while adding doctor speciaility");
            }

            if (locationData == null) {
                setFormData(initialFormData);
                if (formRef.current) {
                    formRef.current.reset();
                }
            }
        }

    };

    const handleHcpModalValue = async (modalvalue, responseData) => {
        const newlyAdded = responseData?.id || responseData?.data?.id || modalvalue;
        await fetchSpecialityData(newlyAdded);
    };

    function handleDrpDuplicates(drpdwnOptions, modalvalue) {

        let isDuplicate = false;

        drpdwnOptions.map((singleoption) => {
            if (singleoption.key.toLowerCase() == modalvalue.toLowerCase()) {
                isDuplicate = true;
            }
        })

        return isDuplicate;
    }

    const handleFieldChange = e => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const breadcrumbItems = [
        { name: 'Dashboard', href: '/main', isActive: false },
        { name: `${locationData != null ? "Edit-HCP" : "Add-HCP"}` , href: paths.hcpSpeciality, isActive: true }
    ];

    const formContent = (
        <Form ref={formRef} onSubmit={handleSubmit} name="specialitymainform">
            <Row className="mb-2">
                <Col md={6}>
                    <Form.Group>
                        <Form.Label className="required">First Name</Form.Label>
                        <Form.Control
                            placeholder='First Name'
                            value={formData.firstname}
                            name="firstname"
                            onChange={handleFieldChange}
                            type="text"
                            size="sm"
                            required
                        />
                    </Form.Group>
                </Col>
                <Col md={6}>
                    <Form.Group>
                        <Form.Label className="required">Last Name</Form.Label>
                        <Form.Control
                            placeholder='Last Name'
                            value={formData.lastname}
                            name="lastname"
                            onChange={handleFieldChange}
                            type="text"
                            size="sm"
                            required
                        />
                    </Form.Group>
                </Col>
            </Row>
            <Row className="mb-2">
                <Col md={6}>
                    <Form.Group>
                        <Form.Label className="required">Speciality</Form.Label>
                        <InputGroup size="sm">
                            <Form.Select
                                name="speciality"
                                value={formData.speciality}
                                onChange={handleFieldChange}
                                size="sm"
                                required
                            >
                                {specialityOptions.map((specialityoption) => {
                                    return (
                                        <option key={specialityoption.value} value={specialityoption.value}>
                                            {specialityoption.key}
                                        </option>
                                    );
                                })}
                            </Form.Select>
                            <Button
                                variant="outline-secondary"
                                size="sm"
                                type="button"
                                onClick={handleHcpModal}
                                title="Add Speciality"
                            >
                                <FontAwesomeIcon icon="plus" />
                            </Button>
                        </InputGroup>
                    </Form.Group>
                </Col>
                <Col md={6}>
                    <Form.Group className="required">
                        <Form.Label className="required">Office Phone</Form.Label>
                        <MaskedInput
                            mask={['+', '1', ' ', '(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
                            className={`form-control form-control-sm ${error.phone ? 'is-invalid' : ''}`}
                            guide={false}
                            placeholder="+1 (XXX) XXX-XXXX"
                            onChange={handleFieldChange}
                            size="sm"
                            name="phone"
                            required
                            value={formData.phone}
                        />
                        <Form.Control.Feedback type="invalid" className="d-block">
                            {error.phone}
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
            </Row>
            <Row className="mb-2">
                <Col md={6}>
                    <Form.Group>
                        <Form.Label>City</Form.Label>
                        <Form.Control
                            placeholder='City'
                            value={formData.city}
                            name="city"
                            onChange={handleFieldChange}
                            type="text"
                            size="sm"
                        />
                    </Form.Group>
                </Col>
                <Col md={6}>
                    <Form.Group>
                        <Form.Label>State</Form.Label>
                        <Form.Select
                            name="state"
                            value={formData.state}
                            onChange={handleFieldChange}
                            size="sm"
                        >
                            {stateoptions.map((stateoption) => {
                                return (
                                    <option key={stateoption.value} value={stateoption.value}>
                                        {stateoption.key}
                                    </option>
                                );
                            })}
                        </Form.Select>
                    </Form.Group>
                </Col>
            </Row>
            <Row className="mb-2">
                <Col md={6}>
                    <Form.Group>
                        <Form.Label>Zip</Form.Label>
                        <Form.Control
                            placeholder='Zip'
                            value={formData.zip}
                            name="zip"
                            onChange={handleFieldChange}
                            type="text"
                            size="sm"
                            isInvalid={!!error.zip}
                        />
                        {error.zip && <div className="text-danger small">{error.zip}</div>}
                    </Form.Group>
                </Col>
                <Col md={6}>
                    <Form.Group>
                        <Form.Label>Address</Form.Label>
                        <Form.Control
                            placeholder='Address'
                            value={formData.address}
                            name="address"
                            onChange={handleFieldChange}
                            type="text"
                            size="sm"
                        />
                    </Form.Group>
                </Col>
            </Row>
            <Row className="mb-2">
                {/* <Col md={6}>
                    <Form.Group>
                        <Form.Label>Email</Form.Label>
                        <Form.Control
                            placeholder='Email'
                            value={formData.email}
                            name="email"
                            onChange={handleFieldChange}
                            size="sm"
                            isInvalid={!!error.email}
                        />
                        {error.email && <div className="text-danger small">{error.email}</div>}
                    </Form.Group>
                </Col> */}
                <Col md={12}>
                    <Form.Group>
                        <Form.Label>Fax</Form.Label>
                        <Form.Control
                            placeholder='Fax'
                            value={formData.fax}
                            name="fax"
                            onChange={handleFieldChange}
                            type="text"
                            size="sm"
                            isInvalid={!!error.fax}
                        />
                        {error.fax && <div className="text-danger small">{error.fax}</div>}
                    </Form.Group>
                </Col>
            </Row>
            <Row className="mb-3">
                <Col md={12}>
                    <Form.Check
                        type='switch'
                        name="isactive"
                        id='isactive'
                        checked={formData.isactive}
                        disabled={!(locationData != null)}
                        onChange={e =>
                            setFormData({
                                ...formData,
                                isactive: e.target.checked
                            })
                        }
                        label='IsActive'
                    />
                </Col>
            </Row>
            <div className="d-flex justify-content-end gap-2 mt-3">
                {isModal && onHide && (
                    <Button variant="secondary" size="sm" onClick={onHide}>
                        Cancel
                    </Button>
                )}
                <Button
                    type="submit"
                    variant="primary"
                    size="sm"
                >
                    {locationData != null ? "Update" : "Add"}
                </Button>
            </div>
            <Row className="mt-2">
                <Col>
                    <Form.Label className="fs-11 text-muted"><span className="text-danger">*</span> indicates required field</Form.Label>
                </Col>
            </Row>
            <HcpModal show={showModal} setShow={setShowModal} handleHcpModalValue={handleHcpModalValue} />
        </Form>
    );

    if (isModal) {
        return formContent;
    }

    return (
        <>
            <CommonBreadCrumb breadcrumbItems={breadcrumbItems} />
            <Card className="mb-3">
                <Card.Header as="h6" className="bg-body-tertiary">
                    {locationData != null ? "Edit HCP" : "Add HCP"}
                </Card.Header>
                <Card.Body>
                    {formContent}
                </Card.Body>
            </Card>
        </>
    );
};

export default AddEditHcpForm;

